import { useContext, useState, useRef } from "react";
import { useLoaderData, useActionData, Form, redirect, json, useSubmit } from 'react-router-dom';

import {getTableForm} from '../utils/api';
import { getLabConfig } from '../utils/api';
import MenuContext from '../store/MenuContext';
import { addRegistration } from '../utils/api';

import FormHelper from '../components/UI/FormHelper';
import RegisterClasses from '../components/Register/Register.module.css';


const RegHeader = () => {
	const menuTheme = useContext(MenuContext);

  return (
		  <div>
		  	<div>
  		      <h2 className={RegisterClasses.testTitle} >Activation Code Request</h2>  		
		      <p >
		        Fill out all required (*) fields prior to clicking save.
		      </p>
		     </div>
		  </div>
		 
  );
};
const Register = () => {

	const [tableForm,PatientPortalCustomerServiceEmail]=useLoaderData();
	const [formError,setFormError] = useState({});
	const formRef = useRef();
	const actionData=useActionData();
	const submit = useSubmit();
	
	const tfHandler = (tferror) => {
		let newtfError={...tferror}
		setFormError(newtfError);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = formRef.current;
		if (!form.checkValidity()) {
		  form.reportValidity(); // Show validation messages
		  return;
		}
		if(Object.keys(formError).length ===0) {
			await submit(event.currentTarget, { method: 'post' });
			//handle errors.....
		}
	};
	const opencontactus = () => {
		window.location.href = `mailto:${PatientPortalCustomerServiceEmail}?body=`;
	};
	const menuTheme = useContext(MenuContext);

  return (

	<div className={RegisterClasses.testInfo}>
	  <div className={RegisterClasses.testInfoContent}>
		 <Form method='post' id='regForm' ref={formRef}>
		 	<RegHeader />
			  <FormHelper TF={tableForm} onTF={tfHandler} />
			  {actionData?.errors && <p>{actionData.errors}</p>}	
			  {actionData?.message && <p>{actionData.message}</p>}
			  <div className={RegisterClasses.buttonArea}> 
			  	<button className={RegisterClasses.buttonDarkBlue} onClick={handleSubmit} >	Save  </button>
			  </div>
		  </Form>
	    </div>
	     <div className={RegisterClasses.buttonArea}>  
  			<div className={RegisterClasses.navArea}>
  				<div className={RegisterClasses.navAreaText} >
				  Need Help? &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					  <button type="button" className={RegisterClasses.buttonDarkBlue} onClick={opencontactus} >
						{'Contact Us'}
					  </button>
				 </div>
			</div>
		</div>
	</div>
  );
};
export default Register;

export async function tfLoader() {
    const response = await getTableForm('DTC:Patient','CreateAccount');
	const resData = await response;
	console.log(resData);
		return resData;
}
export async function supportEmail() {
    const response = await getLabConfig('PATIENTPORTALCUSTOMERSUPPORTEMAIL');
	const resData = await response;
		return resData;
}
export  async function regLoader() {
	return Promise.all([tfLoader(),supportEmail()]);
}
	
export async function newRegAction({ request, params }) {
  const data = await request.formData();
  const regData = Object.fromEntries(data.entries());	

	const response = await addRegistration(regData);
		var messages = {};
  		if (response.status===500) {
			throw json(
			  { message: 'Could not register.' },
			  {
				status: 500,
			  }
			);
		  }
		if (response.status===400) {
			messages.errors="Invalid data";
		}			
		if (response.ok) {
			if (response.status ===200) {
					messages.message="You are already registered.  Please either 1) log in or 2)complete your registration by activating your account."
			}else if (response.status === 300) {
				messages.errors = "Duplicate patients exist, please contact the lab."
			}else{
				messages.message="You are now registered.  Please see your email for further instructions."
				return redirect('../ActivateAccount');
			}
		}
  return messages;
		 
}	